/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-no-bind */
import React, { useState, useEffect } from 'react';
import { Breadcrumb, Button, Empty, Popconfirm, Tooltip } from 'antd';
import { NavLink } from 'react-router-dom';
import { HomeOutlined } from '@ant-design/icons';
import { toast } from 'react-toastify';
import { MdDeleteOutline, MdModeEditOutline } from 'react-icons/md';
import { DragDropContext, Draggable, Droppable } from '@hello-pangea/dnd';
import {
  Container,
  Testimonial,
  TestimonialsList,
  TestimonialsListContent,
  Pagination,
  TestimonialActions,
  TestimonialContent,
  TestimonialSearch,
} from './styles';
import { PageTitle } from '../../components/PageTitle';
import styles from './Depoimentos.module.css';
import { api } from '../../services/api';
import { Loading } from '../../components/Loading';
import { Filters } from './Filters';

import {
  TestimonialAvatar,
  TestimonialContainer,
} from '../ProductUpdate/styles';

export function TechnicalTeam() {
  const [technicalTeam, setTechnicalTeam] = useState([]);
  const [testimonialsTotal, setTestimonialsTotal] = useState(0);
  const [loading, setLoading] = useState(true);
  const [isShowHomeFilter, setIsShowHomeFilter] = useState(false);
  const [isSortLoading, setIsSortLoading] = useState(false);
  const [filterHomeValues, setFilterHomeValues] = useState();
  const [isSearching, setIsSearching] = useState(false);

  const [filtersLoaded, setFiltersLoaded] = useState(false);
  const [searchWord, setSearchWord] = useState('');

  function stringAvatar(name) {
    const nameParts = name.split(' ');

    if (nameParts.length === 1) {
      return `${nameParts[0][0]}${nameParts[0][0]}`.toUpperCase();
    }

    return `${nameParts[0][0]}${nameParts[1][0]}`.toUpperCase();
  }

  function stringToColor(string) {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  }

  const [paginationPage, setPaginationPage] = useState(1);

  async function loadTechnicalTeam() {
    try {
      setLoading(true);
      const response = await api.get(
        `/technical-team/all?page=${paginationPage}`,
      );
      setTestimonialsTotal(response.data.total);
      const technicalTeamFormatted = response.data.technical_team.map(technicalTeamItem => ({
        ...technicalTeamItem,
        text: technicalTeamItem.text ? technicalTeamItem.text.substring(0, 100) : '',
      }));
      setTechnicalTeam(technicalTeamFormatted);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error('Erro ao buscar depoimentos');
    }
  }

  async function searchTechnicalTeam() {
    try {
      const isShowHome = filterHomeValues === 1;
      const isShowHomeTwo = filterHomeValues === 2;
      setLoading(true);
      if (isShowHome) {
        const response = await api.get(
          `/technical-team/search/?is_show_home=true&search_word=${searchWord}`,
        );

        setTechnicalTeam(response.data);
        setIsShowHomeFilter(true);
        setLoading(false);

        return;
      }

      if (isShowHomeTwo) {
        const response = await api.get(
          `/technical-team/search/?is_show_home_two=true&search_word=${searchWord}`,
        );

        setTechnicalTeam(response.data);
        setIsShowHomeFilter(true);
        setLoading(false);

        return;
      }

      const response = await api.get(
        `/technical-team/search/?search_word=${searchWord}`,
      );

      setTechnicalTeam(response.data);
      setLoading(false);

      setIsShowHomeFilter(false);
    } catch (error) {
      setLoading(false);
      toast.error('Erro ao buscar corpo técnico');
    }
  }

  async function deleteTestimonial(testimonailId) {
    try {
      await api.delete(`/technical-team/${testimonailId}`);
      if (isShowHomeFilter) {
        searchTechnicalTeam();
        return;
      }
      loadTechnicalTeam();
      toast.success('Corpo técnico removido com sucesso');
    } catch (error) {
      setLoading(false);
      toast.error('Erro remover corpo técnico');
    }
  }

  useEffect(() => {
    if (!filtersLoaded) return;

    if (isSearching) {
      searchTechnicalTeam();
    } else {
      loadTechnicalTeam();
    }
  }, [filtersLoaded, isSearching, paginationPage]);

  useEffect(() => {
    loadTechnicalTeam();
  }, []);

  useEffect(() => {
    loadTechnicalTeam();
  }, [paginationPage]);

  function handleOnDragEnd(result) {
    if (!result.destination) return;

    const items = Array.from(technicalTeam);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setTechnicalTeam(items);
  }

  async function sortTestimonial() {
    try {
      setIsSortLoading(true);
      await api.post('/technical-team/sort-home', {
        technical_team: technicalTeam,
      });
      setIsSortLoading(false);
      toast.success('Corpo técnico ordenado com sucesso');
    } catch (error) {
      console.log(error);
      setIsSortLoading(false);

      toast.error('Erro ao ordenar corpo técnico');
    }
  }

  function clearSearch() {
    setSearchWord('');
    setIsSearching(false);
    setIsShowHomeFilter(false);
    setFilterHomeValues(null);
    loadTechnicalTeam();
  }

  useEffect(() => {
    const savedFilters = localStorage.getItem('RO:technicalTeamFilters');
    if (savedFilters) {
      const filters = JSON.parse(savedFilters);
      setSearchWord(filters.searchWord || '');
      setIsSearching(filters.isSearching || false);
      setPaginationPage(filters.paginationPage || 1);
      setFilterHomeValues(filters.filterHomeValues || null);
      setIsShowHomeFilter(filters.filterHomeValues || null);
    }

    setFiltersLoaded(true);
  }, []);

  useEffect(() => {
    if (!filtersLoaded) return;

    const filters = {
      searchWord,
      isSearching,
      isShowHomeFilter,
      paginationPage,
      filterHomeValues,
    };

    localStorage.setItem('RO:technicalTeamFilters', JSON.stringify(filters));
  }, [
    searchWord,
    isSearching,
    isShowHomeFilter,
    filtersLoaded,
    paginationPage,
    filterHomeValues,
  ]);

  return (
    <Container>
      <Breadcrumb style={{ marginBottom: 40 }}>
        <Breadcrumb.Item key="/">
          <NavLink to="/">
            <HomeOutlined />
          </NavLink>
        </Breadcrumb.Item>
        <Breadcrumb.Item>Corpo técnico</Breadcrumb.Item>
      </Breadcrumb>

      <PageTitle
        title="Corpo técnico"
        description="Gerenciamento do corpo técnico"
        link="/corpo-tecnico/criar"
        linkTitle="Cadastrar corpo técnico"
      />

      <Filters
        setFilterHomeValues={setFilterHomeValues}
        filterHomeValues={filterHomeValues}
        searchTechnicalTeam={searchTechnicalTeam}
        sortTestimonial={sortTestimonial}
        isSortLoading={isSortLoading}
        setSearchWord={setSearchWord}
        clearSearch={clearSearch}
      />

      {!loading && !!technicalTeam.length && !isShowHomeFilter && (
        <>
          <TestimonialsList>
            <TestimonialsListContent>
              {technicalTeam.map((item) => (
                <Testimonial key={item.name}>
                  <TestimonialContent>
                    <p className={styles.name}>{item.name}</p>
                    {item.photo_url ? (
                      <img
                        className={styles.avatar}
                        src={item.photo_url}
                        style={{ width: 50, height: 50 }}
                        alt=""
                      />
                    ) : (
                      <div
                        className={styles.avatarName}
                        style={{ background: stringToColor(item.name) }}
                      >
                        {stringAvatar(item.name)}
                      </div>
                    )}

                    <p className={styles.textDepoiment}>{item.text}</p>
                  </TestimonialContent>

                  <TestimonialActions>
                    <Tooltip title="Editar corpo técnico">
                      <NavLink to={`/corpo-tecnico/atualizar/${item.id}`}>
                        <Button
                          icon={<MdModeEditOutline size={20} color="#fff" />}
                          style={{ background: '#1677ff' }}
                        />
                      </NavLink>
                    </Tooltip>

                    <Tooltip title="Remover corpo técnico">
                      <Popconfirm
                        title="Remover corpo técnico"
                        description="Tem certeza que deseja remover corpo técnico ?"
                        onConfirm={() => deleteTestimonial(item.id)}
                        okText="Confirmar"
                        cancelText="Não"
                      >
                        <Button
                          icon={<MdDeleteOutline size={20} color="#fff" />}
                          style={{ background: '#ff4d4f', marginLeft: 15 }}
                        />
                      </Popconfirm>
                    </Tooltip>
                  </TestimonialActions>
                </Testimonial>
              ))}
            </TestimonialsListContent>
          </TestimonialsList>

          <Pagination
            onChange={setPaginationPage}
            current={paginationPage}
            total={testimonialsTotal}
            showSizeChanger={false}
            defaultPageSize={6}
          />
        </>
      )}

      {isShowHomeFilter && (
        <TestimonialContainer>
          <DragDropContext onDragEnd={handleOnDragEnd}>
            <Droppable droppableId="characters">
              {(provided) => (
                <div
                  className={styles.moduleList}
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {!!technicalTeam.length &&
                    technicalTeam.map((productTestimonial, index) => (
                      <Draggable
                        key={productTestimonial.id}
                        draggableId={productTestimonial.id}
                        index={index}
                      >
                        {(providedDrag) => (
                          <TestimonialSearch
                            ref={providedDrag.innerRef}
                            {...providedDrag.draggableProps}
                            {...providedDrag.dragHandleProps}
                            className={styles.moduleListItem}
                          >
                            <div>
                              {productTestimonial.photo_url ? (
                                <img
                                  src={productTestimonial.photo_url}
                                  style={{ width: 50, height: 50 }}
                                  alt=""
                                />
                              ) : (
                                <TestimonialAvatar
                                  style={{
                                    background: stringToColor(
                                      productTestimonial.name || '',
                                    ),
                                  }}
                                >
                                  {stringAvatar(productTestimonial.name || '')}
                                </TestimonialAvatar>
                              )}

                              <div className="info">
                                <span>{productTestimonial.name}</span>
                                <p>{productTestimonial.text}</p>
                              </div>
                            </div>

                            <TestimonialActions>
                              <Tooltip title="Editar corpo técnico">
                                <NavLink
                                  to={`/corpo-tecnico/atualizar/${productTestimonial.id}`}
                                >
                                  <Button
                                    icon={(
                                      <MdModeEditOutline
                                        size={20}
                                        color="#fff"
                                      />
                                    )}
                                    style={{ background: '#1677ff' }}
                                  />
                                </NavLink>
                              </Tooltip>

                              <Tooltip title="Remover corpo técnico">
                                <Popconfirm
                                  title="Remover corpo técnico"
                                  description="Tem certeza que deseja remover corpo técnico ?"
                                  onConfirm={() =>
                                    deleteTestimonial(productTestimonial.id)}
                                  okText="Confirmar"
                                  cancelText="Não"
                                >
                                  <Button
                                    icon={
                                      <MdDeleteOutline size={20} color="#fff" />
                                    }
                                    style={{
                                      background: '#ff4d4f',
                                      marginLeft: 15,
                                    }}
                                  />
                                </Popconfirm>
                              </Tooltip>
                            </TestimonialActions>
                          </TestimonialSearch>
                        )}
                      </Draggable>
                    ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>

          {!technicalTeam.length && (
            <Empty
              style={{ padding: '40px 0 ' }}
              description="Nenhum corpo técnico nessa categoria"
            />
          )}
        </TestimonialContainer>
      )}

      {loading && <Loading />}
    </Container>
  );
}
